import { cn } from '@/utils/tailwind.util';
export const ZepQuizBizLogo = ({
  className
}: {
  className?: string;
}) => {
  return <img src="/assets/ZEPQuizBiz-logo.webp" alt="ZEP Quiz for Biz" className={cn('h-[40px] mobile-lg:h-[54px]', className)} data-sentry-component="ZepQuizBizLogo" data-sentry-source-file="ZepQuizBizLogo.tsx" />;
};